import Rest from 'services/data/rest';

const E164_FORMAT = /^\+(\d*?)(\d{3})(\d{3})(\d{4})$/;
const REMOVE_AMERICAN_COUNTRY_CODE = /^(?:1\.|(\d+?\.))(.*?)$/;

export default class PhoneNumber extends Rest {
  static path = 'phonenumber';

  static format(phoneNumber) {
    if (!phoneNumber) return;
    if (!E164_FORMAT.test(phoneNumber)) return phoneNumber;

    const humanReadableNumber = phoneNumber.replace(E164_FORMAT, '$1.$2.$3.$4');
    const withoutAmericanCountryCode = humanReadableNumber.replace(REMOVE_AMERICAN_COUNTRY_CODE, '$1$2');
    return withoutAmericanCountryCode;
  }
}



// WEBPACK FOOTER //
// ./app/services/data/phone-number.js